import { render, staticRenderFns } from "./ChartingWorkspaceTableStage.vue?vue&type=template&id=938f309c&scoped=true&"
import script from "./ChartingWorkspaceTableStage.vue?vue&type=script&lang=js&"
export * from "./ChartingWorkspaceTableStage.vue?vue&type=script&lang=js&"
import style0 from "./ChartingWorkspaceTableStage.vue?vue&type=style&index=0&id=938f309c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938f309c",
  null
  
)

export default component.exports